import 'react-responsive-carousel/lib/styles/carousel.min.css';
import type { ComponentProps, ReactElement } from 'react';
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import { ListItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Carousel } from 'react-responsive-carousel';

type PpCustomCarousel = Partial<ComponentProps<typeof Carousel>> & {
  cssObject?: SerializedStyles;
};

export function CustomCarousel({ cssObject, ...props }: PpCustomCarousel): ReactElement {
  const theme = useTheme();
  const styles = {
    indicator: css`
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin: ${theme.spacing(0, 1)};
      padding: 0;
      cursor: pointer;
    `,
    indicatorActive: css`
      background-color: ${theme.palette.websiteBrand.primary};
    `,
    indicatorUnactive: css`
      background-color: ${theme.palette.websiteBrand.greyscale.grey};
    `,
  };
  return (
    <Carousel
      {...props}
      css={cssObject}
      renderIndicator={(onClickHandler, isSelected, index, label): React.ReactNode => {
        if (isSelected) {
          return (
            <ListItem
              aria-label={`Selected: ${label} ${index + 1}`}
              css={[styles.indicator, styles.indicatorActive]}
              title={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <ListItem
            key={index}
            aria-label={`${label} ${index + 1}`}
            css={[styles.indicator, styles.indicatorUnactive]}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            value={index}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
          />
        );
      }}
    >
      {props.children}
    </Carousel>
  );
}
